__turbopack_context__.v({
  "footerWrapper": "ReserveNowCard-module__KjmEbW__footerWrapper",
  "fullWidth": "ReserveNowCard-module__KjmEbW__fullWidth",
  "headerWrapper": "ReserveNowCard-module__KjmEbW__headerWrapper",
  "modalBody": "ReserveNowCard-module__KjmEbW__modalBody",
  "modalContainer": "ReserveNowCard-module__KjmEbW__modalContainer",
  "reserveVehicleCardWrapper": "ReserveNowCard-module__KjmEbW__reserveVehicleCardWrapper",
  "titleWrapper": "ReserveNowCard-module__KjmEbW__titleWrapper",
});
